"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.preview.errors.noId': 'No payment ID provided',
    'payment.preview.errors.loadFailed': 'Failed to load payment details',
    'payment.preview.refreshed': 'Payment details refreshed',
};
